const logStatsActions = {
  LOG_CV_PRINT: 'LOG_CV_PRINT',
  LOG_CV_DOWNLOAD: 'LOG_CV_DOWNLOAD',
  LOG_JOB_STATISTICS_VIEW: 'LOG_JOB_STATISTICS_VIEW',

  logCvPrint: (payload: { applicationId: number }) => ({
    type: logStatsActions.LOG_CV_PRINT,
    payload,
  }),
  logCvDownload: (payload: { applicationId: number }) => ({
    type: logStatsActions.LOG_CV_DOWNLOAD,
    payload,
  }),
  logJobStatisticsView: (payload: { projectId: number }) => ({
    type: logStatsActions.LOG_JOB_STATISTICS_VIEW,
    payload,
  }),
};

export default logStatsActions;
